"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSFER_FILE_NAME_MAX_BYTES = exports.TRANSFER_VERSION_MAX_BYTES = void 0;
/**
 * 펌웨어 버전명의 실질 상한 — **전문의 `전송 버전` 칸이 ANS 20바이트**이기 때문이다
 * (사양서 V0.06 §2.3.4·§2.3.5). 인코딩은 CP949라 **한글 10자 · 영문 20자**다.
 *
 * ⚠ **값이지 타입이 아니다 — 런타임으로 반입한다.** 화면이 자기 숫자를 따로 적으면 서버 검증과
 * 갈려 "폼은 통과하는데 저장이 400"이 된다(shared `index.ts`의 반입 기준 그대로다).
 *
 * ⚠ **자르지 않고 등록에서 막는 값이다.** 이 버전명은 단말이 0003 요청에 되실어 보내는
 * **대조 키**라, 전송 시점에 자르면 그 대조가 영영 어긋난다. DB 컬럼은 50자로 두되(이미 저장된
 * 행을 손대지 않는다) 새로 들어오는 값만 막는다.
 */
exports.TRANSFER_VERSION_MAX_BYTES = 20;
/**
 * 전송 파일명 칸 — CP949 50바이트 (2026-09-15 소장 요청, 20 → 50). 버전 칸(20)과 **다른 폭**이다.
 * 확장자를 포함한 `SW/HW이름_YYYYMMDD.zip` 꼴이 20을 넘어 늘렸다. 파일명이 실리는 1002·0003·0004·0005의
 * 파일명 필드가 이 폭을 쓰고, 서버는 등록 파일명이 이 폭·ASCII 안이면 그대로 내려보낸다.
 */
exports.TRANSFER_FILE_NAME_MAX_BYTES = 50;
